const base = process.env.REACT_APP_API_BASE_URL || '//localhost:8080/api';

const API_ENDPOINTS = {
  BASE: base,
  ROLES: `${base}/v1/roles`,
  TASKS: `${base}/v1/tasks`,
  USERS: `${base}/v1/users`,
  DEVICES: `${base}/v1/devices`,
  DEVICE_IMAGES: `${base}/v1/devices/{device_id}/road-images`,
  DEVICETYPE_CATEGORIES: `${base}/v1/devicetype-categories`,
  DEVICE_MODELS: `${base}/v1/devices/devicemodels`,
  SERVICE_ORDERS_DEVICE: `${base}/v1/devices/id/service-orders`,
  CONTRACTS: `${base}/v1/contracts`,
  AUTH_LOGIN: `${base}/v1/auth/login`,
  INTEGRATIONS: `${base}/v1/integrations`,
  ORGANIZATIONS: `${base}/v1/organizations`,
  DEVICE_DATA: `${base}/v1/devices/{device_id}`,
  SERVICE_CENTERS: `${base}/v1/service-centers`,
  SERVICE_ORDERS: `${base}/v1/service-orders`,
  INSTALLATION: `${base}/v1/installation-orders`,
  CONST_ANALYTICS_REFS: `${base}/v1/const/analytics/refs`,
  HEART_BEAT_DEVICES: `${base}/v1/devices/heartbeat/skipped`,
  CONST_ANALYTICS_PERIODS: `${base}/v1/const/analytics/periods`,
  CONST_DEVICE_LIFECYCLES: `${base}/v1/const/devices/lifecycles`,
  ANALYTICS_TRENDS_ORG_GROUPS: `${base}/v1/analytics/trends/organizations/{organizations_id}`,
  SERVICE_SCHEDULES_PUT_THRESHOLD: `${base}/v1/organizations/{orgId}/devices/{deviceId}/service-schedule`,
  ANALYTICS_SERVICE_SCHEDULES_ORG_GROUPS: `${base}/v1/analytics/service-schedules/organizations/{organizations_id}`,
  RESET_SERVICE_SCHEDULES: `${base}/v1/organizations/{orgId}/devices/{deviceId}/service-schedule/{serviceScheduleId}/reset`,
  ANALYTICS_TRENDS: `${base}/v1/analytics/trends?orgId={orgId}&groupId={groupId}&deviceId={deviceId}&ref={ref}&period={period}&date={date}`,
  ANALYTICS_SERVICE_SCHEDULES: `${base}/v1/analytics/service-schedules?orgId={orgId}&groupId={groupId}&deviceId={deviceId}&period={period}&date={date}`,
  MONITORING: `${base}/v1/monitoring`,
  MONITORING_LOGS: `${base}/v1/monitoring/{monitoringId}/logs`,
  MONITORING_LOGS_ID_PATCH: `${base}/v1/monitoring/{monitoringId}`,
  MONITORING_ERROR_CODES: `${base}/v1/monitoring/error-codes`,
  MONITORING_STATUS_CODES: `${base}/v1/monitoring/status-codes`,
  USER_CONFIG: `${base}/v1/users/config`,
  NOTIFY: `${base}/v1/notify`,
  STANCODES: `${base}/v1/stancodes`,
  PACKAGES: `${base}/v1/packages`,
  TECHNICIANS: `${base}/v1/technicians`,
};

export default API_ENDPOINTS;
